export default __webpack_public_path__ + "static/media/TotalWarseries.c03c5a2f.jpg";